import { createI18n } from 'vue-i18n';
import enLocale from 'element-plus/es/locale/lang/en';
import zhLocale from 'element-plus/es/locale/lang/zh-cn';
import * as zhMessages from './zh';
import * as enMessages from './en';

function escapeMessageLiterals(messages) {
    if (typeof messages === 'string') {
        return messages.replace(/[@|]/g, character => `{'${character}'}`);
    }
    if (Array.isArray(messages)) {
        return messages.map(escapeMessageLiterals);
    }
    if (messages && typeof messages === 'object') {
        return Object.fromEntries(Object.entries(messages).map(([key, value]) => [key, escapeMessageLiterals(value)]));
    }
    return messages;
}

let language = (navigator.language || navigator.browserLanguage).toLowerCase();
language = (language === 'zh-cn') ? 'zh-CN' : 'en-US';
localStorage.LANG = localStorage.LANG || language;

const i18n = createI18n({
    legacy: true,
    locale: localStorage.LANG,
    messages: {
        'zh-CN': { ...escapeMessageLiterals(zhMessages), ...zhLocale },
        'en-US': { ...escapeMessageLiterals(enMessages), ...enLocale },
    },
});

i18n.t = (...args) => i18n.global.t(...args);
Object.defineProperty(i18n, 'locale', {
    get: () => i18n.global.locale,
    set: locale => { i18n.global.locale = locale; },
});

export default i18n;
